import React from "react";
import { LocationSelector } from "../../../components/location-selector/location-selector";

const StepAddress: React.FC = () => {
  return <LocationSelector />;
};

export default StepAddress;